define('customPlugins/atnKoScrollbar',[
        'knockout', 'lodash', 'jquery', './utils'
    ],
    function(ko, _, $, utils) {
        'use strict';

        ko.bindingHandlers.atnKoScrollbar = {
            init: function(element, valueAccessor) {
                if (!utils.isInternetExplorer()) {
                    //  only works for non-IE browsers
                    if(valueAccessor().extensions.setScrollPosition){
                        valueAccessor().extensions.setScrollPosition.subscribe(function(value){
                            if(_.isNumber(value)){
                                $(element).scrollTop(value);
                                $(element).perfectScrollbar('update');
                            }
                        });
                    }
                    var options = ko.utils.unwrapObservable(valueAccessor()),
                        throttle = _.isNumber(options.extensions.throttle) ? options.extensions.throttle : 250;
                    $(element).perfectScrollbar('destroy').perfectScrollbar(options.options);
                    // creating a throttled listener to update scrollbar
                    _.defer(function() {
                        var lastTime = new Date().getTime();
                        _.delay(initPerfectScrollbar, 500);
                        $(element).on('mouseenter', '.ps-scrollbar-y-rail,.ps-scrollbar-x-rail', updateScrollbar);
                        $(element).on('scroll', returnScrollPositionToCallback);
                        $(element).on(utils.events.ATN_ALTERED, updateScrollbar);

                        /**
                         * function to be called to update the scrollbar, it also
                         *     throttles the updation of scrollbar
                         * @return {undefined}
                         */
                        function updateScrollbar() {
                            var newTime = new Date().getTime();
                            if (newTime - lastTime > throttle) {
                                lastTime = newTime;
                                $(element).perfectScrollbar('update');
                            }
                        }

                        function returnScrollPositionToCallback(){
                            if(options.extensions.scrollTopPosition){
                                options.extensions.scrollTopPosition(element.scrollTop);
                            }
                        }

                        function initPerfectScrollbar(){
                            $(element).scrollTop(0);
                            $(element).perfectScrollbar('update');
                        }
                    });
                }
            }
        };
    });
